export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#111111',
    light: 'rgba(17, 17, 17, 0.04)'
  },
  secondary: {
    main: '#0081C4',
    contrastText: '#0A5285',
  },
  text: {
    primary: '#111111',
    secondary: '#51626B',
    alternate: '#23B0E7',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    main: '#FFFFFF',
    paper: '#FFF',
    default: '#FFF',
    header: '#C3DFFC',
    footer: '#F8FBFE',
    level2: '#f7f8fb',
    level1: '#FFF',
    tableHead: '#111111',
    tableSubhead: '#F8FBFE',
    tableBorder: '#7D808880',
    tableAlternate: '#F8F8F8',
    alternate: '#E3F1FD',
    success: '#DBEFDC',
    error: '#FFEAEA',
    secondary: '#F8D859',
    light: '#F8FBFE',
    secondaryLight: '#d7dfee',
    definition: 'rgba(247, 247, 247, 0.60)',
    comparison: 'linear-gradient(103deg, #1F9CDD 3.31%, #077BBC 80.44%)',
    star: "#0081C4",
    bar: '#111111'
  },
  verticalBar: {
    used: '#7BD6D0',
    unused: '#7BD6D01a',
    unlimited: '#C0C0C0',
  }
};
